module.exports = __webpack_public_path__ + "assets/img/swiper-3-4.3bb08e15.jpg";